import axios from '@/libs/api.request'

/**
 * 获取第三方API配置列表
 * @param {Number} page - 页码
 * @param {Number} page_size - 每页数量
 * @param {String} keyword - 搜索关键字
 */
export const getThirdPartyApiList = (page, page_size, keyword) => {
  return axios.request({
    url: '/api/third-party-api/list',
    method: 'get',
    params: {
      page,
      page_size,
      keyword
    }
  })
}

/**
 * 获取第三方API配置详情
 * @param {String|Number} id - 配置ID
 */
export const getThirdPartyApiDetail = (id) => {
  return axios.request({
    url: `/api/third-party-api/detail/${id}`,
    method: 'get'
  })
}

/**
 * 创建第三方API配置
 * @param {Object} data - 配置数据
 */
export const createThirdPartyApi = (data) => {
  return axios.request({
    url: '/api/third-party-api/create',
    method: 'post',
    data
  })
}

/**
 * 更新第三方API配置
 * @param {String|Number} id - 配置ID
 * @param {Object} data - 配置数据
 */
export const updateThirdPartyApi = (id, data) => {
  return axios.request({
    url: `/api/third-party-api/update/${id}`,
    method: 'put',
    data
  })
}

/**
 * 删除第三方API配置
 * @param {String|Number} id - 配置ID
 */
export const deleteThirdPartyApi = (id) => {
  return axios.request({
    url: `/api/third-party-api/delete/${id}`,
    method: 'delete'
  })
}

/**
 * 测试第三方API配置
 * @param {Object} data - 测试数据
 */
export const testThirdPartyApi = (data) => {
  return axios.request({
    url: '/api/third-party-api/test',
    method: 'post',
    data
  })
}
